<template>
  <div class="notice_content_wrap" @click="hideComponent">
    <div class="notice_content">
      <div class="notice_header">
        <div class="close_btn" @click="closeHandler"><v-icon>clear</v-icon></div>
        <div class="header_title">{{notice.title}}</div>
      </div>
      <div class="content" id="content">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'noticeDetail',
    props: {
      closeHandler: Function,
      date: String,
      notice: Object
    },
    methods: {
      hideComponent (e) {
        if (e.target === e.currentTarget) {
          this.closeHandler()
        }
      },
      hideComponent_key (event) {
        if (event.keyCode === 27) {
          this.closeHandler()
        }
      }
    },
    created () {
      window.addEventListener('keyup', this.hideComponent_key)
    },
    mounted () {
      document.getElementById('content').innerHTML = this.notice.contents
    },
    beforeDestory () {
      window.removeEventListener('keyup', this.hideComponent_key)
    }
  }
</script>

<style scoped>
  .notice_content_wrap {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc(100% - 151px);
    height: calc(100vh - 50px);
    top: 51px;
    left: 152px;
    background: rgba(000, 000, 000, 0.1);
    z-index: 99;
  }
  .header_title, .close_btn {
    height: 30px;
    line-height: 30px;
  }
  .notice_content {
    width: 50%;
    height: 50vh;
    min-width: 450px;
    min-height: 250px;
    margin-top: -30vh;
    background: #fff;
    border: 1px solid #ccc;
  }
  .header_title {
    border-bottom: 2px solid #cee3f0;
    padding-left: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .close_btn {
    width: 30px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    float: right;
    border-bottom: 2px solid #cee3f0;
  }
  i {
    vertical-align: middle;
    font-size: 25px;
    color: #81b71a;
    margin-top: -3px;
  }
  .close_btn:hover {
    cursor: pointer;
  }
  .close_btn:hover i {
    color: #ff5652;
  }

  .content {
    max-height: calc(50vh - 42px);
    min-height: 210px;
    padding: 5px 20px;
    overflow: auto;
  }
  @media screen and (max-width: 800px){
    .notice_content_wrap {
      width: 100%;
      height: calc(100vh - 40px);
      margin: 0;
      top: 40px;
      left: 0;
    }
    .notice_content {
      margin-top: -20vh;
      width: 90%;
      min-width: 0;
      height: 60vh;
    }
  }
</style>



// WEBPACK FOOTER //
// NoticeDetail.vue?7d862bca